import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import Login2 from '@/views/Login2'
import Homepage from "@/views/homepage/Homepage"
import Searchresult from "@/views/Searchresult/Searchresult"
import Studentdetails from "@/views/Studentdetails/Studentdetails"
import Traindetails from "@/views/Traindetails/Traindetails"
import Reportpage from "@/views/Reportpage/Reportpage"
import Chartpage from "@/views/chartpage/chartpage"
import homepagetwo from "@/views/homepagetwo/homepagetwo"
import Adminhomepage from "@/views/Adminhomepage/Adminhomepage"
// import Studentdetails from "@/views/Studentdetails/Studentdetails"
import MorePic from '@/views/morePic/morePic'
import MoreRecord from '@/views/moreRecord/moreRecord'
import ReportDetail from '@/views/reportDetail/reportDetail'

// Studentdetails
// import { component } from 'vue/types/umd'

Vue.use(Router)
const routes = [{
        path: '/',
        name: 'Login2',
        component: Login2
    },
    {
        path: '/',
        name: 'Login',
        component: Login
    },
    {
        path: "/homepage",
        name: "Homepage",
        component: Homepage,
    },
    {
        path: "/morePic",
        name: "MorePic",
        component: MorePic,
    },
    {
        path: "/moreRecord",
        name: "moreRecord",
        component: MoreRecord,
    },
    {
        path: "/reportDetail",
        name: "ReportDetail",
        component: ReportDetail,
    },
    {
        path: "/searchresult",
        name: "Searchresult",
        component: Searchresult,
    },
    {
        path: "/studentdetails",
        name: "Studentdetails",
        component: Studentdetails,
    },
    {
        path: "/traindetails",
        name: "Traindetails",
        component: Traindetails,
    },
    {
        path: "/Reportpage",
        name: "Reportpage",
        component: Reportpage,
    },
    {
        path: "/Chartpage",
        name: "Chartpage",
        component: Chartpage,
    },
    {
        path: "/homepagetwo",
        name: "homepagetwo",
        component: homepagetwo,
    },   
    {
        path: "/Adminhomepage",
        name: "Adminhomepage",
        component: Adminhomepage,
    },    
]
const router = new Router({
    mode: "history",
    base: '/user/',
    routes,
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js